export default {
  showHistoryDialog: false,
  distributionMailFlag: false,
  sourceAddress: "",
  subject: "",
  content: "",
  showCancelDialog: false,
  cancelItem: null,
};
